import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../common/CommonComponents/Buttons";
import { makeStyles } from "@material-ui/core/styles";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { StyledDatePicker, StyledDefaultTextField } from "../fui/FuiStyles";
import { Radio } from "@material-ui/core";
import moment from "moment";
import {
    Box,
    Typography,
    Stepper,
    Step,
    StepButton,
    Button,
    InputLabel,
    MenuItem,
    TextField,
    FormControlLabel,
    Checkbox,
    DialogContent,
    DialogContentText,
    CircularProgress,
    InputAdornment,
    FormControl,
    RadioGroup,
    Tooltip,
    IconButton
} from "@material-ui/core";
import { AcceptButton } from "../common/CommonComponents/Buttons";
import AddIcon from "@material-ui/icons/Add";
import Axios from "axios";
import base from "../../config";
import { connect } from "react-redux";
import "./custom.css";
import { StyledFormControl, StyledSelect, StyledTextField, StyledFileCopyIcon, StyledTooltip } from "../fui/FuiStyles";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { StyledClickableElementForFile } from "../ec2management/ServerList/styledServerList";
import { checkWBSECode } from "../fui/forms/CommonFunctions";
import { appNameProjectId } from "../fui/Constants/ProductIds";
import uuidv4 from "uuidv4";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Autocomplete from '@material-ui/lab/Autocomplete';

/**
   * @author shilpa.adikeshava
   * @version 1.0
 */



const useStyles = makeStyles(theme => ({
    paper: {
        position: "absolute",
        width: 720,
        backgroundColor: theme.palette.background.paper,
        // boxShadow: theme.shadows[5],
        boxShadow: "unset",
        padding: "15px 32px 32px 32px"
    },
    requestOpenAIButton: {
        backgroundColor: theme.palette.admin.main,
        color: "white",
        float: "right"
    },
    actionButton: {
        border: "2px solid  #7500C0 !important",
        color: " #7500C0 !important",
        background: "white"
    },
    backButton: {
        borderColor: "rgb(158,158,158) !important",
        color: "rgb(158,158,158) !important"
    }
}));

const provisioningURL = process.env.REACT_APP_PROVISION_URL;

const steps = ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'Step 5'];

const RequestForm = (props) => {
    const {
        email,
    } = props;
    const classes = useStyles();
    const idToken = localStorage.getItem("token");
    const currentTime = moment().format();
    const l3Url = "https://mywizard-aiops.accenture.com/resources/support-requests/";

    const [createdBy, setCreatedBy] = useState("");
    const [open, setOpen] = React.useState(false);
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState({});
    const [file, setFile] = useState("");
    const [pptName, setPptName] = useState("");
    const [pptFile, setPPTFile] = useState(null);
    const [pptBase64URL, setPptBase64URL] = useState("");
    const [domainContextRoot, setDomainContextRoot] = useState("");
    const [modelList, setModelList] = useState([]);
    const [model, setModel] = useState("");
    const [availableRegions, setAvailableRegions] = useState([]);
    const [preferredRegion, setPreferredRegion] = useState("");
    const [regionList, setRegionList] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState("");
    const [manager, setManager] = useState("");
    const [usecase, setUsecase] = useState("The LLM will be used for the AD application hosted in Accenture Cloud for Client");
    const [requestType, setRequestType] = useState("");
    const [accessType, setAccessType] = useState("");
    const [accessTypeValue, setAccessTypeValue] = useState([]);
    const [configurationType, setConfigurationType] = useState("client");
    const [wbseCode, setWbseCode] = useState("");
    const [sapContractID, setSAPContractID] = useState("");
    const [clientname, setClientname] = useState("myWizard AiOps");
    const [endtoendID, setEndToEndID] = useState("");
    const [secondaryPoc, setSecondaryPoc] = useState("");
    const [atrURL, setAtrURL] = useState("");
    const [assetName, setAssetName] = useState("");
    const [otherAssetName, setOtherAssetName] = useState("");
    const [env, setEnv] = useState("");

    const [loading, setLoading] = useState(false);
    const [finalSubmitLoading, setFinalSubmitLoading] = useState(true);
    const [finalSubmitError, setFinalSubmitError] = useState(true);
    const [fetchAvailableRegionsLoading, setFetchAvailableRegionsLoading] = useState(false);


    const [isAllInputsCorrect, setIsAllInputsCorrect] = useState(false);
    const [isPPTValid, setIsPPTValid] = useState(false);
    const [isRequestTypeValid, setIsRequestTypeValid] = useState(false);
    const [isAccessTypeValid, setIsAccessTypeValid] = useState(false);
    const [isAtrURLValid, setIsAtrURLValid] = useState(false);
    const [isAssetnameValid, setIsAssetnameValid] = useState(false);
    const [isUsecaseValid, setIsUsecaseValid] = useState(false);
    const [isManagerValid, setIsManagerValid] = useState(false);
    const [isTCAgreed, setIsTCAgreed] = useState(false);
    const [isConfigurationTypeValid, setIsConfigurationTypeValid] = useState(false);
    const [isSAPContractIDValid, setIsSAPContractIDValid] = useState(true);
    const [isClientNameValid, setIsClientNameValid] = useState(false);

    const [atrVersion, setAtrVersion] = useState("");
    const [instanceState, setInstanceState] = useState("");
    const [instanceOwner, setInstanceOwner] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
    const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
    const [sapContractIDLoading, setSapContractIDLoading] = useState(false);
    const [domainContextRootLoading, setDomainContextRootLoading] = useState(false);
    const [isDomainContextRootValid, setIsDomainContextRootValid] = useState(false);
    const [orderItemUId, setOrderItemUId] = useState("");
    const [orderUId, setOrderUId] = useState("");

    let list = "poornna.a.ganeshan,d.sudalaimani,riyadh.m.omar,naveen.kalasamudram,srinivas.boga,ariel.a.callanta"
    const managersList = list.split(",");
    const sortManagersList = managersList.sort();

    let assetList = [
        { value: "Infra360 HyperV", label: "Infra360 Hypervisor - Hyper V" },
        { value: "Infra360 NPS", label: "Infra360 NPS" },
        { value: "Cloud360 Alibaba", label: "Cloud360 Alibaba" },
        { value: "Infra360 Exchange", label: "Infra360 Exchange" },
        { value: "AlertCentre", label: "AlertCentre" },
        { value: "Network360 SDWAN", label: "Network360 SDWAN" },
        { value: "Infra360 Host", label: "Infra360 Host" },
        { value: "Cloud360 Azure", label: "Cloud360 Azure" },
        { value: "Infra360 vCenter", label: "Infra360 Hypervisor - vCenter" },
        { value: "Stack Health Diagnostic", label: "Stack Health Diagnostic" },
        { value: "API360", label: "API360" },
        { value: "Infra360 NNMi", label: "Infra360 NNMi" },
        { value: "AppLog360", label: "AppLog360" },
        { value: "Stack360", label: "Stack360" },
        { value: "Infra360 NPS", label: "Infra360 NPS" },
        { value: "Infra360 Port", label: "Infra360 Port" },
        { value: "CMDBLite", label: "CMDBLite" },
        { value: "Infra360 SNMP - Traps", label: "Infra360 SNMP - Traps" },
        { value: "Config Wizard", label: "Config Wizard" },
        { value: "URL360", label: "URL360" },
        { value: "DB360", label: "DB360" },
        { value: "Infra360 WinEventLog", label: "Infra360 WinEventLog" },
        { value: "Host Process360", label: "Host Process360" },
        { value: "MW360", label: "MW360" },
        { value: "SAP Java", label: "GenWizard for SAP Java" },
        { value: "SAP ABAP", label: "GenWizard for SAP ABAP" },
        { value: "SAP Ariba", label: "GenWizard for SAP Ariba" },
        { value: "SAP BTP Cloud Connector", label: "GenWizard for SAP BTP Cloud Connector" },
        { value: "SAP BOBJ", label: "GenWizard for SAP BOBJ" },
        { value: "SAP Configuration Addon", label: "GenWizard for SAP Configuration Addon" },
        { value: "SAP Cloud Platform Integration", label: "GenWizard for SAP Cloud Platform Integration" },
        { value: "SAP HANA", label: "GenWizard for SAP HANA" },
        { value: "SAP Landscape Cockpit", label: "GenWizard for SAP Landscape Cockpit" },
        { value: "SAP MTC BPM", label: "GenWizard for SAP Meter-to-Cash Business Process Monitoring" },
        { value: "SAP Process Integration", label: "GenWizard for SAP Process Integration" },
        { value: "SAP PTP BPM", label: "GenWizard for SAP Procure-to-Pay Business Process Monitoring" },
        { value: "SAP Reporting Addon", label: "GenWizard for SAP Reporting Addon" },
        { value: "SAP Security Addon", label: "GenWizard for SAP Security Addon" },
        { value: "Chatbot", label: "Chatbot" },
        { value: "ATR Jira Plugin", label: "ATR Jira Plugin" },
        { value: "ATR Rundeck Agent", label: "ATR Rundeck Agent" },
        { value: "AJ", label: "Automation Journey" },
        { value: "AP", label: "Automation Planner" },
        { value: "Splunk Watch", label: "Splunk Watch" },
        { value: "Accenture SSP", label: "Accenture Shared ServiceNow Plugin" },
        { value: "ATR Cherwell Plugin", label: "ATR Cherwell Plugin" },
        { value: "GenWizard CTAS", label: "GenWizard Codeless Test Automation Suite" },
        { value: "Embedded RPA", label: "Embedded RPA" },
        { value: "SOG_Brandrisk", label: "SOG_Brandrisk" },
        { value: "SAP OTC BPM", label: "myWizard AiOps for SAP Order to Cash Business Process Monitoring" },
        { value: "AFM", label: "Automation Fabric Monitoring" },
        { value: "Cisco - EOX", label: "Cisco - EOX" },
        { value: "Salesforce", label: "GenWizard for Salesforce" },
        { value: "SAP SLT", label: "GenWizard for SAP SLT" },
        { value: "SOG_RDD", label: "SOG_RDD" },
        { value: "myBuddy as-a-service", label: "myBuddy as-a-service" },
        { value: "Automation Addon", label: "GenWizard for Automation Addon" },
        { value: "SI", label: "Service Integrator" },
        { value: "SAP AlertCenter Addon", label: "GenWizard for SAP AlertCenter Addon" },
        { value: "SAP SF", label: "GenWizard for SAP Success Factors" },
        { value: "Smart Alerts", label: "Smart Alerts" },
        { value: "Smart Capacity Prediction", label: "Smart Capacity Prediction" },
        { value: "PMOHub", label: "PMOHub" },
        { value: "DevOps TFS Addon", label: "DevOps TFS Addon" },
        { value: "DevOps Jira Addon", label: "DevOps Jira Addon" },
        { value: "DevOps NewSource Addon", label: "DevOps NewSource Addon" },
        { value: "DevOps Rally Addon", label: "DevOps Rally Addon" },
        { value: "DevOps TeamCity Addon", label: "DevOps TeamCity Addon" },
        { value: "DevOps Jfrog Addon", label: "DevOps Jfrog Addon" },
        { value: "DevOps Hiptest Addon", label: "DevOps Hiptest Addon" },
        { value: "DevOps ATR Addon", label: "DevOps ATR Addon" },
        { value: "DevOps Jenkins Addon", label: "DevOps Jenkins Addon" },
        { value: "DevOps Azure Pipeline Addon", label: "DevOps Azure Pipeline Addon" },
        { value: "DevOps ALM Addon", label: "DevOps ALM Addon" },
        { value: "DevOps Concourse Addon", label: "DevOps Concourse Addon" },
        { value: "DevOps Gitlab Addon", label: "DevOps Gitlab Addon" },
        { value: "DevOps Github Addon", label: "DevOps Github Addon" },
        { value: "DevOps Bamboo Addon", label: "DevOps Bamboo Addon" },
        { value: "DevOps nexusIQ", label: "DevOps nexusIQ" },
        { value: "DevOps BitBucket Addon", label: "DevOps BitBucket Addon" },
        { value: "DevOps TFSGit Addon", label: "DevOps TFSGit Addon" },
        { value: "ATR", label: "Automatic Ticket Resolver" },
        { value: "Q++", label: "Quasar++" },
        { value: "KM", label: "Klewer and Quasar" },
        { value: "GenWizard RE", label: "Reverse Engineering" },
        { value: "TA", label: "Ticket Analysis" },
        { value: "GenWizard AD", label: "GenWizard AD" },
        { value: "Stack", label: "Stack Monitoring Suite" },
        { value: "DevOps", label: "DevOps Analytics" },
        { value: "Sharepoint", label: "GenWizard AiOps Sharepoint Addon" },
        { value: "CSCC", label: "Cloud Security and Compliance Checker" },
        { value: "RE", label: "Report Extractor" },
        { value: "ATA", label: "Automatic Ticket Assignment" },
        { value: "Batch", label: "GenWizard AiOps Batch" },
        { value: "SAP360", label: "GenWizard AiOps SAP360" },
        { value: "Cloud Chaser", label: "Cloud Chaser" },
        { value: "RPA", label: "GenWizard AiOps RPA" },
        { value: "StormWatch", label: "StormWatch" },
        { value: "RemedyForce", label: "RemedyForce connector" },
        { value: "Cloud Chargeback", label: "Cloud Chargeback" },
        { value: "Oracle360", label: "Oracle360" },
        { value: "Other", label: "Other" },
    ];

    let environments = [
        { value: "Prod", label: "Production" },
        { value: "Pre-Prod", label: "Pre-Production" },
        { value: "Demo", label: "Demo" },
        { value: "UAT", label: "UAT" },
        { value: "SIT", label: "SIT" },
        { value: "Stage", label: "Stage" },
        { value: "Dev", label: "Development" },
    ];

    useEffect(() => {
        if (email) {
            let eid = email ? email.split("@")[0] : "";
            setCreatedBy(eid);
        }
    }, [email]);

    useEffect(() => {
        fetchModelNames();
        const interval = setInterval(() => {
            fetchModelNames();
        }, 20000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        setOrderUId(uuidv4());
        // Using a different generation for this value due to new requirements.
        setOrderItemUId(uuidv4());
    }, []);

    const handleClose = () => {
        props.close()
    };

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = () => {
        const newActiveStep =
            isLastStep() && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed,
                // find the first step that has been completed
                steps.findIndex((step, i) => !(i in completed))
                : activeStep + 1;
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSave = (step) => {
        if (step + 1 == "1") {
            if (accessType === " " || accessType === "") {
                toast.error("Please select a platform to continue")
                setIsAllInputsCorrect(false);
            } else {
                axiosCall();
            }
        } else if (step + 1 == "2") {
            if (configurationType === "client" && isAccessTypeValid) {
                if (isAssetnameValid && isWBSECodeValid && isSAPContractIDValid && wbseCode !== "" && sapContractID !== "" && secondaryPoc !== "" && env !== "") {
                    if (assetName === "Other" && otherAssetName === "") {
                        toast.error("Please input valid details in all the fields to continue.")
                        setIsAllInputsCorrect(false);
                    } else {
                        axiosCall();
                    }
                } else {
                    toast.error("Please input valid details in all the fields to continue.")
                    setIsAllInputsCorrect(false);
                }
            } else if (configurationType === "internal" && isAccessTypeValid) {
                if (isAssetnameValid && isWBSECodeValid && wbseCode !== "" && secondaryPoc !== "" && env !== "") {
                    if (assetName === "Other" && otherAssetName === "") {
                        toast.error("Please input valid details in all the fields to continue.")
                        setIsAllInputsCorrect(false);
                    } else {
                        axiosCall();
                    }
                } else {
                    toast.error("Please input valid details in all the fields to continue.")
                    setIsAllInputsCorrect(false);
                }
            }
            // } else if (requestType === "ATR") {
            //     if (isAtrURLValid) {
            //         setLoading(true)
            //         checkATRVersion(atrURL);
            //         // axiosCall();
            //     } else {
            //         toast.error("Please input ATR URL to proceed further.")
            //         setIsAllInputsCorrect(false);
            //     }
            // }
        } else if (step + 1 == "3") {
            if (model.length !== 0 && selectedRegion !== "" && domainContextRoot !== "" && isDomainContextRootValid) {
                axiosCall();
            } else {
                toast.error("Please input all the fields!")
                setIsAllInputsCorrect(false);
            }
        } else if (step + 1 == "4") {
            // if (requestType === "Other") {
            if (isManagerValid && usecase !== "") {
                axiosCall();
            } else {
                toast.error("Please input all the fields!")
                setIsAllInputsCorrect(false);
            }
            // } 
            // else {
            //     if (isManagerValid && isUsecaseValid && isAtrURLValid && isPPTValid) {
            //         axiosCall();
            //     } else {
            //         toast.error("Please input all the fields!")
            //         setIsAllInputsCorrect(false);
            //     }
            // }
        } else {
            axiosCall();
        }
    };

    const handleComplete = () => {
        handleCompleteOtherAppRequest();
        submitForm();
        // if (requestType === "ATR") {
        //     if (atrURL !== "") {
        //         checkATRVersion(atrURL);
        //     } else {
        //         toast.error("Please input ATR URL to proceed further.")
        //     }
        // } else {
        //     handleCompleteOtherAppRequest();
        // }
    }

    const handleCompleteATRRequest = () => {
        setFinalSubmitLoading(true)
        setFinalSubmitError(false)
        const newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted({ 0: true, 1: true, 2: true, 3: true, 4: true });
        const formData = {
            OtherApp: "ATR",
            ATRurl: atrURL,
            CustomerEnterpriseID: email,
            // useCase: usecase,
        }
        const url = provisioningURL;

        if (isAtrURLValid) {
            setIsAllInputsCorrect(true);
            handleNext();

            //API call to store other details in DynamoDB
            Axios.post(url, formData, {
                headers: { "Content-Type": "application/json", Authorization: idToken },
                params: {
                    "CustomerEnterpriseID": email,
                }
            }).then((res) => {
                // console.log(res.data)
                setFinalSubmitLoading(false)
                setFinalSubmitError(false)
            }).catch((err) => {
                console.log("Async error", err);
                setFinalSubmitError(true)
            });
        } else {
            toast.error("Please read & agree to the terms & conditions below to proceed!")
            setIsAllInputsCorrect(false);
        }
    };

    const handleCompleteOtherAppRequest = () => {
        // setFinalSubmitLoading(true)
        // setFinalSubmitError(false)
        const newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted(newCompleted);
        const formData = new FormData();
        const url = `${base.urls.apis.azure}/openai-access`;
        const bucket = "openai-access-certificates"
        const pptToString = JSON.stringify(pptFile)
        const selectedFiles = { "pptfile": pptToString }
        // if (isAssetnameValid && isUsecaseValid && isManagerValid && isTCAgreed && isPPTValid) {
        if (isAssetnameValid && isManagerValid && isTCAgreed) {
            setIsAllInputsCorrect(true);
            handleNext();
            //API call to upload image to S3
            // Axios.post(selectedFiles, {
            //     headers: { Authorization: idToken },
            //     params: {
            //         "inititive": "na"
            //     }
            // }).then((res) => {
            //     // console.log(res.data)
            //     setFinalSubmitLoading(false)
            // }).catch((err) => {
            //     console.log("Async error", err);
            // });
            //API call to store other details in DynamoDB
            Axios.post(url, formData, {
                headers: { Authorization: idToken },
                params: {
                    "assetName": assetName,
                    "managerName": manager,
                    "step": activeStep + 1,
                    "username": email,
                    "usecase": usecase,
                    "SAPContractID": sapContractID,
                    "WBSEcode": wbseCode,
                    "ClientName": clientname,
                    "SecondaryPOC": secondaryPoc,
                    "TentativeServiceEndDate": selectedDate,
                    "AccessType": accessType,
                    "certImage": ""
                }
            }).then((res) => {
                // console.log(res.data)
                // setFinalSubmitLoading(false)
                setFinalSubmitError(false)
            }).catch((err) => {
                console.log("Async error", err);
                setFinalSubmitError(true)
            });
        } else {
            toast.error("Please read & agree to the terms & conditions below to proceed!")
            setIsAllInputsCorrect(false);
        }

    };

    const submitForm = () => {
        // setOrderItemUId(uuidv4());
        const newEntryURL = `${base.urls.apis.order}/update/new`;
        setFinalSubmitLoading(true);
        const productUId = appNameProjectId.openAI;
        const userOrder = [
            endtoendID === "" ? domainContextRoot : endtoendID,
            productUId,
            createdBy,
            sapContractID === "" ? domainContextRoot : sapContractID,
        ].join("");
        const submitData = {
            OrderUId: `${orderUId}`,
            UserOrder: `${userOrder}`,
            ClientName: "myWizard AiOps",
            EndToEndUId: endtoendID === "" ? domainContextRoot : endtoendID,
            DMSId: `${endtoendID}`,
            DeployRegion: "UNKNOWN",
            CloudPlatform: "AWS",
            MyClient: "myWizard AiOps",
            OS: "CentOS",
            DomainContextRoot: `${domainContextRoot}`,
            InstanceType: "Dedicated",
            OrderItems: [
                {
                    ProjectId: endtoendID === "" ? domainContextRoot : endtoendID,
                    OrderItemUId: `${orderItemUId}`,
                    CreatedBy: `${createdBy}`,
                    CreateDate: `${currentTime}`,
                    ModifiedBy: "",
                    ModifiedDate: "",
                    ResolvedBy: "",
                    ResolvedDate: "",
                    Status: "Placed",
                    ProductUId: `${productUId}`,
                    VendorName: "CAM",
                    InstanceType: "Dedicated",
                    Notes: "",
                    E2EProjectId: "undefined",
                    Users: [{ Id: "UNKNOWN" }],
                    Config: [
                        {
                            Key: "EndToEndUId",
                            Value: endtoendID === "" ? domainContextRoot : endtoendID,
                        },
                        {
                            Key: "DMSId",
                            Value: endtoendID === "" ? domainContextRoot : endtoendID,
                        },
                        {
                            Key: "ProjectName",
                            Value: `${domainContextRoot}`,
                        },
                        {
                            Key: "AAAMTermsConditions",
                            Value: "yes"
                        },
                        {
                            Key: "CustomerMobileNo",
                            Value: "UNKNOWN"
                        },
                        {
                            Key: "SAPContractID",
                            Value: sapContractID === "" ? domainContextRoot : sapContractID,
                        },
                        {
                            Key: "DomainContextRoot",
                            Value: `${domainContextRoot}`,
                        },
                        {
                            Key: "GeographicArea",
                            Value: "UNKNOWN"
                        },
                        {
                            Key: "InstanceType",
                            Value: "Dedicated"
                        },
                        {
                            Key: "GDPR",
                            Value: "no"
                        },
                        {
                            Key: "DeploymentRegion",
                            Value: `${selectedRegion}`.toUpperCase().replace(/\s+/g, '')
                        },
                        {
                            Key: "BenefitsExpected",
                            Value: 1
                        },
                        {
                            Key: "Environment",
                            Value: `${env}`
                        },
                        {
                            Key: "Tier",
                            Value: ""
                        },
                        {
                            Key: "TentativeServiceEndDate",
                            Value: `${selectedDate}T00:00:00.000Z`
                        },
                        {
                            Key: "DailyDataVolume",
                            Value: 0
                        },
                        {
                            Key: "ConcurrentUsers",
                            Value: 0
                        },
                        {
                            Key: "CustomerEnterpriseID",
                            Value: `${email}`,
                        },
                        {
                            Key: "WBSEcode",
                            Value: `${wbseCode}`,
                        },
                        {
                            Key: "RITM",
                            Value: "",
                        },
                        {
                            Key: "OpenAI",
                            Value: ""
                        },
                        {
                            Key: "ClientName",
                            Value: "myWizard AiOps"
                        },
                        {
                            Key: "DeployRegion",
                            Value: "UNKNOWN"
                        },
                        {
                            Key: "VendorName",
                            Value: "CAM"
                        },
                        {
                            Key: "AdminDistributionGroup",
                            Value: "UNKNOWN"
                        },
                        {
                            Key: "Users",
                            Value: "UNKNOWN"
                        },
                        {
                            Key: "ServiceGroup",
                            Value: "UNKNOWN"
                        },
                        {
                            Key: "UsersDistributionGroup",
                            Value: "UNKNOWN"
                        },
                        {
                            Key: "RequestNotes",
                            Value: `${usecase}`,
                        },
                        {
                            Key: "SecondaryPOC",
                            Value: `${secondaryPoc}`
                        },
                        {
                            Key: "ConfigurationType",
                            Value: `${configurationType}`
                        },
                        {
                            Key: "AaamPlatformType",
                            Value: "Genwizard AiOps LLM"
                        },
                        {
                            Key: "ProductInstanceUrl",
                            Value: null
                        },
                        {
                            Key: "CloudPlatform",
                            Value: ""
                        },
                        {
                            Key: "MyClient",
                            Value: ""
                        },
                        {
                            Key: "BaseOS",
                            Value: ""
                        },
                        {
                            Key: "RDSMultiAZ",
                            Value: false
                        },
                        {
                            Key: "IsMultiZoneDeployment",
                            Value: false
                        },
                        {
                            Key: "DialogFlow",
                            Value: "disabled"
                        },
                        {
                            Key: "DialogFlowClientToken",
                            Value: ""
                        },
                        {
                            Key: "DialogFlowDevToken",
                            Value: ""
                        },
                        {
                            Key: "Initiative",
                            Value: "myWizard AiOps"
                        },
                        {
                            Key: "AccessType",
                            Value: accessTypeValue
                        },
                        {
                            Key: "AssetName",
                            Value: assetName
                        },
                        {
                            Key: "ChatGPT",
                            Value: `${model}`
                        },
                        {
                            Key: "PreferredRegion",
                            Value: `${preferredRegion}`
                        },
                        {
                            Key: "Approver",
                            Value: `${manager}@accenture.com`
                        },
                        {
                            Key: "ApprovalStatus",
                            Value: "Pending Approval"
                        },

                    ],
                    DeliveryOptions: null,
                    ArtifactAttributes: null,
                    AccessLinkURL: "",
                },
            ],
            __v: 0,
        };

        // console.log("submitData::", submitData);
        const configArray = submitData.OrderItems[0].Config;

        //check if Approver is equal to Requester or not
        if (createdBy === manager) {
            const approvalStatus = configArray.find(item => item.Key === "ApprovalStatus");
            approvalStatus['Value'] = "Approved";

            //hit update DocumentDB url & trigger mail endpoint
            Axios
                .post(newEntryURL, submitData, { headers: { Authorization: idToken } })
                .then((res) => {
                    // hit final provisioning endpoint
                    Axios
                        .post(provisioningURL, submitData, { headers: { Authorization: idToken } })
                        .then((res) => {
                            setFinalSubmitError(false);
                            setFinalSubmitLoading(false);
                        })
                        .catch((err) => {
                            setFinalSubmitError(true);
                            setFinalSubmitLoading(false);
                        });
                })
                .catch((err) => {
                    setFinalSubmitError(true);
                    setFinalSubmitLoading(false);
                });
        } else {
            //hit update DocumentDB url & trigger mail endpoint
            
            Axios.post(newEntryURL, submitData, { headers: { Authorization: idToken } })
                .then((res) => {
                    setFinalSubmitError(false);
                    setFinalSubmitLoading(false);
                })
                .catch((err) => {
                    setFinalSubmitError(true);
                    setFinalSubmitLoading(false);
                });
        }

    }

    const axiosCall = () => {
        const formData = new FormData();
        const url = `${base.urls.apis.azure}/openai-access`;
        const bucket = "azureopenaiaccess"
        const ppturl = `${base.urls.apis.azure}/${bucket}`;
        const newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted(newCompleted);
        handleNext();
        const pptToString = JSON.stringify(pptFile)
        const selectedFiles = { "pptfile": pptToString }
        // //API call to upload image to S3
        Axios.post(ppturl, selectedFiles, {
            headers: { Authorization: idToken },
            params: {
                "inititive": "na"
            }
        }).then((res) => {
            // console.log(res.data)
            // setFinalSubmitLoading(false)
        }).catch((err) => {
            console.log("Async error", err);
        });
        //API call to store other details in DynamoDB
        Axios.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data", Authorization: idToken },
            params: {
                "assetName": assetName,
                "managerName": manager,
                "step": activeStep + 1,
                "usecase": usecase,
                "SAPContractID": sapContractID,
                "WBSEcode": wbseCode,
                "ClientName": clientname,
                "SecondaryPOC": secondaryPoc,
                "TentativeServiceEndDate": selectedDate,

            }
        }).then((res) => {
            // console.log(res.data)
        }).catch((err) => {
            console.log("Async error", err);
        });
    }

    const checkATRVersion = (url) => {
        setLoading(true);
        const urls = `${base.urls.apis.azure}/checkatrversion?ATRurl=${url}`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            setAtrVersion(data.ATRversion)
            setInstanceState(data.InstanceState)
            setInstanceOwner(data.InstanceOwner)
            checkATRDetails(data);
            setLoading(false)
        }).catch((error) => {
            console.log('Error', error)
            setLoading(false)
        })
    };

    const checkATRDetails = (data) => {
        const version = data[0] ? parseInt(data[0].Atrversion) : ""
        if (data.message === "Not an Owner") {
            setErrorMsg("Oops! You don't have ownership rights for this ATR. For further assistance, kindly reach out to the instance owner or enter the ATR URL which you own.")
        } else if (data.message === "stopped") {
            setErrorMsg("Oops! This ATR is currently not running. Please start the instance and proceed with your request.")
        } else if (data.message === "Invalid URL") {
            setErrorMsg("Oops! You have entered an invalid ATR URL. Please enter a valid URL to proceed with your request.")
        } else if (data == null) {
            setErrorMsg("Oops! You have entered an invalid ATR URL. Please enter a valid URL to proceed with your request.")
        } else if (version >= 4) {
            setIsAtrURLValid(true)
            handleCompleteATRRequest();
        } else if (version < 4) {
            setErrorMsg("Oops! This ATR version is not compatible with OpenAI. Please upgrade by raising L3 support ticket. Thank you!")
        } else if (data[0].Atrversion === "N/A") {
            setErrorMsg("Oops! We are facing heavy traffic in our system, please try again later.")
        } else {
            setIsAtrURLValid(false)
            setErrorMsg("Oops! We are facing heavy traffic in our system, please try again later.")
        }
    };

    const options = {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: idToken,
        },
    };

    const fetchFilePresignedUrl = (event) => {
        event.preventDefault();
        const urls = `${base.urls.apis.faq}/aiops_genai_workshop.pdf?inititive=na`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            window.open(data[0], "_blank");
        }).catch((error) => {
            console.log('Error', error)
        })
    };

    function checkType(input, fieldName) {
        if (fieldName === "accessType") {
            if (!input || input === "") {
                toast.error('Please select access type.');
                setIsAccessTypeValid(false);
            } else {
                setIsAccessTypeValid(true);
                setAccessType(input);
                let itemsToAdd = [];

                if (input === 'OpenAI+APIM') {
                    // itemsToAdd = ['OpenAI', 'APIM'];
                    itemsToAdd = { "0": "OpenAI", "1": "APIM" };
                } else {
                    // itemsToAdd = [input];
                    itemsToAdd = { "0": input };
                }
                setAccessTypeValue(itemsToAdd);
            }
        }
        // if (!input || input === "") {
        //     toast.error('Please select request type.');
        //     setIsRequestTypeValid(false);
        // } else {
        //     setIsRequestTypeValid(true);
        //     setRequestType(input)
        // }
    }

    function checkAtrURL(input) {
        if (!input || input === "") {
            setIsAtrURLValid(false);
        } else {
            setIsAtrURLValid(true);
            setAtrURL(input)
        }
    }

    function checkManager(input) {
        if (!input || input === "") {
            setIsManagerValid(false);
        } else {
            setIsManagerValid(true);
            setManager(input)
        }
    }

    function checkUseCase(input) {
        if (!input || input === "") {
            setIsUsecaseValid(false);
            let str = input;
            str = str.replace(/^\s+/, '');
            setUsecase(str);
        } else {
            setIsUsecaseValid(true);
            let str = input;
            str = str.replace(/^\s+/, '');
            setUsecase(str);
        }
    }

    function checkAssetName(input) {
        if (!input || input === "") {
            setIsAssetnameValid(false);
        } else {
            setIsAssetnameValid(true);
            setAssetName(input)
        }
    }

    function checkConfigurationType(input) {
        if (!input || input === "") {
            setIsConfigurationTypeValid(false);
        } else {
            setIsConfigurationTypeValid(true);
            setConfigurationType(input)
        }
    }

    function checkSAPContractID(input) {
        document.getElementById("clientDetails").style.display = "none";
        if (!input || input === "") {
            setIsSAPContractIDValid(false);
            let str = input;
            str = str.replace(/^\s+/, '');
            setSAPContractID(input);
        } else {
            setSAPContractID(input)
            if (input.length == 10) {
                const fetchFuiDetailsUrl = `${base.urls.apis.fulfillment}/client-details?contract_code=${input}`;
                setSapContractIDLoading(true)
                Axios.get(fetchFuiDetailsUrl, options).then((res) => {
                    const data = res.data
                    if (data[0] == "N/A") {
                        setSapContractIDLoading(false)
                        setIsSAPContractIDValid(false);
                        document.getElementById("clientDetails").style.display = "none";
                    } else {
                        setSapContractIDLoading(false)
                        setIsSAPContractIDValid(true);
                        setClientname(data[0])
                        setEndToEndID(data[1])
                        document.getElementById("clientDetails").style.display = "block";
                    }
                }).catch((error) => {
                    console.log('Error', error)
                    setSapContractIDLoading(false)
                    setIsSAPContractIDValid(true);
                })
            } else {
                setIsSAPContractIDValid(false);
            }
            // setIsSAPContractIDValid(true);
            // setSAPContractID(input)
        }
    }

    const checkRootExisted = (input) => {
        setDomainContextRoot(input);
        setDomainContextRootLoading(true);

        if (!input || input === "") {
            setIsDomainContextRootValid(false);
        } else {
            const fetchRootUrl = `${base.urls.apis.fui}`;
            const re = /^[a-z0-9]*$/;
            if (re.test(input)) {
                Axios.get(fetchRootUrl, {
                    headers: { Authorization: idToken },
                    params: {
                        domain_context_root: input,
                        inititive: "aaammg",
                    },
                }).then((res) => {
                    const data = res.data
                    setDomainContextRootLoading(false);
                    if (data === "true") {
                        setIsDomainContextRootValid(false);
                    } else {
                        setIsDomainContextRootValid(true);
                    }
                }).catch((err) => {
                    console.log("ERR::", err);
                    setIsDomainContextRootValid(false);
                    setDomainContextRootLoading(false);
                });

            } else {
                setIsDomainContextRootValid(false);
                setDomainContextRootLoading(false);
            }
        }
    };

    function checkClientName(input) {
        if (!input || input === "") {
            setIsClientNameValid(false);
        } else {
            setIsClientNameValid(true);
            setClientname(input)
        }
    }

    function checkPPT(input) {
        if (!input || input === "") {
            setIsPPTValid(false);
        }
        else if (!input.name.match(/\.(ppt|pptx)$/)) {
            toast.error('Only PPT & PPTX formats are allowed');
            setIsPPTValid(false);
        } else {
            setIsPPTValid(true);
            setFile(URL.createObjectURL(input));
        }
    }

    const getBase64 = file => {
        return new Promise(resolve => {
            let fileInfo;
            let baseURL = "";
            // Make new FileReader
            let reader = new FileReader();

            // Convert the file to base64 text
            reader.readAsDataURL(file);

            // on reader load somthing...
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };

    const handleUploadPPTFileInputChange = e => {
        let file = pptFile;

        checkPPT(e.target.files[0])

        file = e.target.files[0];
        setPptName(file.name)

        getBase64(file)
            .then(result => {
                setPptBase64URL(result);
                setPPTFile(result);
            })
            .catch(err => {
                console.log(err);
            });

    };

    function handleChange(e, fieldName) {
        if (fieldName === "TentativeServiceEndDate") {
            setSelectedDate(e)
        } else if (fieldName === "assetName") {
            checkAssetName(e.value)
            setIsTCAgreed(false);
        } else {
            const value = e.target.value;
            e.preventDefault();
            if (fieldName === "accessType") {
                checkType(value, fieldName);
                setIsTCAgreed(false);
                setErrorMsg("");
            }
            if (fieldName === "requestType") {
                checkType(value, fieldName)
                setIsTCAgreed(false);
                setErrorMsg("");
            }
            if (fieldName === "atrURL") {
                checkAtrURL(value)
                setIsTCAgreed(false);
                setErrorMsg("");
            }
            // if (fieldName === "assetName") {
            //     checkAssetName(value)
            //     setIsTCAgreed(false);
            // }
            if (fieldName === "otherAssetName") {
                setOtherAssetName(value);
            }
            if (fieldName === "env") {
                setEnv(value);
            }
            if (fieldName === "domainContextRoot") {
                checkRootExisted(value);
            }
            if (fieldName === "model") {
                setModel(value);
                setPreferredRegion("");
                setSelectedRegion("");
                fetchAvailableRegions("reg", value);

            }
            // if (fieldName === "preferredRegion") {
            //     setPreferredRegion(value);
            //     // checkRegions(value);
            //     fetchAvailableRegions(value, model);
            // }
            if (fieldName === "selectedRegion") {
                setSelectedRegion(value);                
            }
            if (fieldName === "usecase") {
                checkUseCase(value)
                // setIsTCAgreed(false);
            }
            if (fieldName === "manager") {
                checkManager(value)
                setIsTCAgreed(false);
            }
            if (fieldName === "tc") {
                setIsTCAgreed(e.target.checked)
            }
            if (fieldName === "configurationType") {
                setWbseCode("");
                setSecondaryPoc("");
                setClientname("");
                setSAPContractID("");
                setAssetName("");
                checkConfigurationType(value)
                setIsTCAgreed(false);
            }
            if (fieldName === "WBSEcode") {
                setWbseCode(value)
                setIsWBSECodeValid(checkWBSECode(value));
            }
            if (fieldName === "SAPContractID") {
                checkSAPContractID(value)
                setIsTCAgreed(false);
            }
            if (fieldName === "SecondaryPOC") {
                setIsTCAgreed(false);
                setSecondaryPoc(value);
            }
            if (fieldName === "ClientName") {
                checkClientName(value)
                setIsTCAgreed(false);
            }

        }

    }

    const fetchModelNames = () => {
        const urls = `${base.urls.apis.azure}/openai-access/read/available`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            setModelList(data);
            // setModelList(data.filter(item => item.trim() !== ''));
        }).catch((error) => {
            console.log(error)
        })
    }

    // const fetchAvailableRegions = (reg, model) => {
    const fetchAvailableRegions = (reg, model) => {
        setFetchAvailableRegionsLoading(true);

        const urls = `${base.urls.apis.azure}/openai-access/read/one?filter=DeploymentName&filterValue=${model}&PreferredRegion=Azure`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            // setAvailableRegions(data.filter(item => item.trim() !== ''));
            setRegionList(data.filter(item => item.trim() !== ''));
            setFetchAvailableRegionsLoading(false);
        }).catch((error) => {
            console.log(error)
            setFetchAvailableRegionsLoading(false);
        })
    }

    const checkRegions = (value) => {
        if (value === "Azure") {
            setRegionList(availableRegions)
        } else if (value === "Aws") {
            const awsToAzureMap = {
                sydney: ['AUSTRALIAEAST', 'EASTUS', 'EASTUS2', 'CANADAEAST', 'NORTHCENTRALUS'],
                virginia: ['EASTUS', 'EASTUS2', 'CANADAEAST', 'NORTHCENTRALUS'],
                singapore: ['EASTUS', 'EASTUS2', 'CANADAEAST', 'NORTHCENTRALUS'],
                frankfurt: ['FRANCECENTRAL', 'SWEDENCENTRAL', 'SWITZERLANDNORTH'],
                ireland: ['FRANCECENTRAL', 'SWEDENCENTRAL', 'SWITZERLANDNORTH'],
                tokyo: ['JAPANEAST'],
                london: ['UKSOUTH']
                // '*'  omitted
            };

            const inputSet = new Set(availableRegions.map(r => r.trim().toUpperCase()));

            const matchedAwsRegions = Object.entries(awsToAzureMap).filter(([awsRegion, azureList]) => {
                return azureList.some(region => inputSet.has(region));
            }).map(([awsRegion]) => awsRegion);

            setRegionList(matchedAwsRegions);
        } else {
            setRegionList([]);
        }
    }

    return (
        // <div className={classes.root}>
        //     <DialogContent>
        //         <DialogContentText id="alert-dialog-descreption">
        //             <Typography sx={{ mt: 2, mb: 1 }} style={{ textAlign: "center" }}>
        //                 <p style={{ fontSize: "1.4rem", color: " #0041F0 !important" }}><b>This feature is temporarily unavailable</b>&#x1F61E;</p>
        //                 <p>If you require OpenAI, please raise a service request using this{" "}
        //                     <a href={l3Url} target="_blank" rel="noopener noreferrer">
        //                         link
        //                     </a>.
        //                     Thank you for your understanding.
        //                 </p>
        //                 <br></br>
        //                 <div style={{ float: "right" }}>
        //                     <PrimaryButton
        //                         data-cy="dialogOkButton"
        //                         variant="outlined"
        //                         onClick={handleClose}
        //                         label={"Close"}
        //                         className={classes.requestOpenAIButton}
        //                     />
        //                 </div>

        //             </Typography>
        //         </DialogContentText>
        //     </DialogContent>

        // </div>
        <div className={classes.root}>
            <DialogContent>
                <DialogContentText id="alert-dialog-descreption">
                    <Box sx={{ width: '100%' }}>
                        {/* <Stepper nonLinear activeStep={activeStep}>
                            {steps.map((label, index) => (
                                <Step key={label} completed={completed[index]}>
                                    <StepButton color="inherit">
                                        {label}
                                    </StepButton>
                                </Step>
                            ))}
                        </Stepper> */}
                        <div>
                            {allStepsCompleted() && isAllInputsCorrect ? (
                                <React.Fragment>
                                    <br></br>
                                    <br></br>
                                    {finalSubmitLoading ? (
                                        <div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <CircularProgress size={40} />
                                            </div>
                                            <div
                                                style={{
                                                    paddingTop: "8%",
                                                    paddingBottom: "8%",
                                                    textAlign: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <h4>Please wait.... </h4>
                                                <p>Submitting your request</p>
                                                <p style={{ lineHeight: "0.1px" }}><i>This may take up to a minute....</i></p>
                                            </div>
                                        </div>

                                    ) : (
                                        !finalSubmitError ?
                                            <div style={{ textAlign: "center" }}>
                                                <Typography>Your Request ID: <b>{orderItemUId}</b><CopyToClipboard text={orderItemUId}>
                                                    <Tooltip title="Copy">
                                                        <IconButton>
                                                            <StyledFileCopyIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </CopyToClipboard></Typography>
                                                <Typography sx={{ mt: 2, mb: 1 }} style={{ textAlign: "center" }}>
                                                    <p style={{ fontSize: "1.1rem", color: " #0041F0 !important" }}><b>Thank you for submitting your request for OpenAI access!</b></p>
                                                    <p>Once your request has been reviewed & actioned, you will receive a notification via email.</p>
                                                    <br></br>
                                                    <div style={{ float: "right" }}>
                                                        <PrimaryButton
                                                            data-cy="dialogOkButton"
                                                            variant="outlined"
                                                            onClick={handleClose}
                                                            label={"Close"}
                                                            className={classes.requestOpenAIButton}
                                                        />
                                                    </div>

                                                </Typography>
                                            </div>
                                            : <Typography sx={{ mt: 2, mb: 1 }} style={{ textAlign: "center" }}>
                                                <p style={{ fontSize: "1.1rem", color: " #0041F0 !important" }}><b>Oops! Something went wrong.</b></p>
                                                <p>We're sorry, but your request couldn't be processed at the moment due to heavy traffic. Please try again after some time. We apologize for any inconvenience caused. Thank you for your understanding.
                                                </p>
                                                <br></br>
                                                <div style={{ float: "right" }}>
                                                    <PrimaryButton
                                                        data-cy="dialogOkButton"
                                                        variant="outlined"
                                                        onClick={handleClose}
                                                        label={"Close"}
                                                        className={classes.requestOpenAIButton}
                                                    />
                                                </div>

                                            </Typography>
                                    )}
                                    <br></br>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <Typography sx={{ mt: 2, mb: 1, py: 1 }} style={{ paddingBottom: "5%" }}>
                                        {
                                            (() => {
                                                if (activeStep + 1 == 1) {
                                                    return (
                                                        <div>
                                                            {/* <p>We are excited to enable your access to LLM services and resources. Before we proceed, we kindly request you to complete the mandatory data security training program. This training is essential to ensure that you are well-prepared and equipped to handle our data securely, maintaining its confidentiality, integrity, and availability.</p> */}
                                                            {/* <p>
                                                                <a href="https://mylearning.accenture.com/mylearningui/learner/coursedetail/1826391" target="_blank" rel="noopener noreferrer">
                                                                    Link to Training
                                                                </a>
                                                            </p> */}
                                                            {/* <br></br> */}
                                                            <p>We’re excited to provide you access to LLM services that can help streamline tasks, enhance productivity, and support smarter decision-making. To get started, please select the platform that best fits your needs.</p>
                                                            {/* <p><b>Please select your preferred LLM Service Provider</b></p> */}
                                                            <StyledFormControl variant="outlined" margin="dense">
                                                                <InputLabel htmlFor="outlined-requesttype">Platform</InputLabel>
                                                                <StyledSelect
                                                                    onChange={(e) => handleChange(e, "accessType")} label="Platform" value={accessType}
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>--Select a platform--</em>
                                                                    </MenuItem>
                                                                    {/* <MenuItem value="OpenAI">Azure OpenAI</MenuItem> */}
                                                                    <MenuItem value="OpenAI">Azure OpenAI</MenuItem>
                                                                    {/* <MenuItem value="APIM"> Azure APIM </MenuItem> */}
                                                                    <MenuItem disabled value="Bedrock"> AWS Bedrock </MenuItem>
                                                                    <MenuItem disabled value="Gemini"> GCP Gemini </MenuItem>
                                                                </StyledSelect>
                                                            </StyledFormControl>
                                                            {/* <p><b>Are you raising Open AI Integration request for an existing ATR application or for other application? Please select the type of request below.</b></p>
                                                            <StyledFormControl variant="outlined" margin="dense" fullWidth>
                                                                <InputLabel htmlFor="outlined-requesttype">Request Type</InputLabel>
                                                                <StyledSelect
                                                                    onChange={(e) => handleChange(e, "requestType")} label="Request Type" value={requestType}
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>--Select Request Type--</em>
                                                                    </MenuItem>
                                                                    <MenuItem value="ATR"> Existing myWizard ATR </MenuItem> */}
                                                            {/* <MenuItem value="NewATR"> New ATR </MenuItem> */}
                                                            {/* <MenuItem value="Other"> Other Applications </MenuItem>
                                                                </StyledSelect>
                                                            </StyledFormControl> */}
                                                            {/* {requestType === "ATR" ?
                                                                <div>
                                                                    <StyledFormControl variant="outlined" margin="dense">
                                                                        <InputLabel htmlFor="outlined-plan-and-scope-select">
                                                                            Chat GPT
                                                                        </InputLabel>
                                                                        <StyledSelect
                                                                            defaultValue="4"
                                                                            // onChange={(e) => handleDevOpsAddon(e)}
                                                                            label="Chat GPT"
                                                                            fullWidth
                                                                        >
                                                                            <MenuItem value="">
                                                                                <em>--Select version--</em>
                                                                            </MenuItem>
                                                                            <MenuItem value="4">4</MenuItem>
                                                                        </StyledSelect>
                                                                    </StyledFormControl>
                                                                    <StyledFormControl>
                                                                        <TextField
                                                                            margin="dense"
                                                                            variant="outlined"
                                                                            placeholder="e.g. https://[regioncode]-[domaincontextroot].atrmywizard-aiops.com/atr/signin"
                                                                            onChange={(e) => handleChange(e, "atrURL")}
                                                                            label="ATR URL"
                                                                            InputProps={{
                                                                                endAdornment: (
                                                                                    <InputAdornment position="end">
                                                                                        {loading ?
                                                                                            <CircularProgress size={20} />
                                                                                            :
                                                                                            " "}
                                                                                    </InputAdornment>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    </StyledFormControl>
                                                                </div> : ""
                                                            }

                                                            <div style={{ background: "red", display: errorMsg ? "block" : "none" }}>
                                                                <p style={{ color: "white", padding: "1%" }} ><b>{errorMsg}</b></p>
                                                            </div> */}

                                                            {/* {requestType === "Other" ?
                                                                <div>
                                                                    <p><b>To better assist you, could you please let us know if you are a client or an internal user?</b></p>
                                                                    <FormControl variant="outlined" style={{ marginTop: "-1%" }}>
                                                                        <RadioGroup
                                                                            aria-label="configurationType"
                                                                            name="configurationType"
                                                                            value={configurationType}
                                                                            onChange={(e) => handleChange(e, "configurationType")}
                                                                            row
                                                                        >
                                                                            <FormControlLabel
                                                                                value="client"
                                                                                control={<Radio color="primary" />}
                                                                                label={`CLIENT`}
                                                                            />
                                                                            <FormControlLabel
                                                                                value="internal"
                                                                                control={<Radio color="primary" />}
                                                                                label={`INTERNAL USER`}
                                                                            />
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                    <StyledFormControl variant="outlined" margin="dense" fullWidth>
                                                                        <InputLabel htmlFor="outlined-assetname">Asset name</InputLabel>
                                                                        <StyledSelect
                                                                            onChange={(e) => handleChange(e, "assetName")} label="Asset Name" value={assetName}
                                                                        >
                                                                            <MenuItem value="">
                                                                                <em>--Select Asset Name--</em>
                                                                            </MenuItem>
                                                                            <MenuItem value="Ticket Analyser">Ticket Analyser</MenuItem>
                                                                            <MenuItem value="Stack Monitoring Suite">Stack Monitoring Suite</MenuItem>
                                                                            <MenuItem value="DevOps Analytics">DevOps Analytics</MenuItem>
                                                                            <MenuItem value="myWizard AiOps Sharepoint Addon">myWizard AiOps Sharepoint Addon</MenuItem>
                                                                            <MenuItem value="Cloud Security and Compliance Checker">Cloud Security and Compliance Checker</MenuItem>
                                                                            <MenuItem value="Report Extractor">Report Extractor</MenuItem>
                                                                            <MenuItem value="Automatic Ticket Assignment">Automatic Ticket Assignment</MenuItem>
                                                                            <MenuItem value="myWizard AiOps Batch">myWizard AiOps Batch</MenuItem>
                                                                            <MenuItem value="myWizard AiOps SAP360">myWizard AiOps SAP360</MenuItem>
                                                                            <MenuItem value="Cloud Chaser">Cloud Chaser</MenuItem>
                                                                            <MenuItem value="myWizard AiOps RPA">myWizard AiOps RPA</MenuItem>
                                                                            <MenuItem value="StormWatch">StormWatch</MenuItem>
                                                                            <MenuItem value="RemedyForce connector">RemedyForce connector</MenuItem>
                                                                            <MenuItem value="Cloud Chargeback">Cloud Chargeback</MenuItem>
                                                                            <MenuItem value="Oracle360">Oracle360</MenuItem>
                                                                            <MenuItem value="Other">Other</MenuItem>
                                                                        </StyledSelect>
                                                                        <StyledFormControl variant="outlined" margin="dense" fullWidth>
                                                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                                <StyledDatePicker
                                                                                    autoOk
                                                                                    label="Tentative Service End Date"
                                                                                    id="TentativeServiceEndDate"
                                                                                    value={selectedDate}
                                                                                    onChange={(e) => {
                                                                                        setSelectedDate(e);
                                                                                        return handleChange(
                                                                                            moment(e).format("YYYY-MM-DD"),
                                                                                            "TentativeServiceEndDate"
                                                                                        );
                                                                                    }}
                                                                                    variant="inline"
                                                                                    inputVariant="outlined"
                                                                                    format="MM/dd/yyyy"
                                                                                    disableCloseOnSelect={true}
                                                                                    disablePast={true}
                                                                                />
                                                                            </MuiPickersUtilsProvider>
                                                                        </StyledFormControl>
                                                                        <StyledFormControl>
                                                                            <TextField
                                                                                label="WBSE Code"
                                                                                id="WBSEcode"
                                                                                margin="dense"
                                                                                variant="outlined"
                                                                                value={wbseCode}
                                                                                onChange={(e) => handleChange(e, "WBSEcode")}
                                                                                helperText={
                                                                                    !isWBSECodeValid &&
                                                                                    "Please provide a valid WBSE Code."
                                                                                }
                                                                                error={!isWBSECodeValid}
                                                                            />
                                                                        </StyledFormControl>
                                                                        <StyledFormControl>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                placeholder="Please provide the Secondary POC"
                                                                                onChange={(e) => handleChange(e, "SecondaryPOC")}
                                                                                label="Secondary POC"
                                                                                margin="dense"
                                                                                value={secondaryPoc}
                                                                            />
                                                                        </StyledFormControl>
                                                                    </StyledFormControl>
                                                                </div>
                                                                : ""
                                                            } */}
                                                            {/* {
                                                                configurationType === "client" && requestType === "Other" ?
                                                                    <div>
                                                                        <StyledFormControl>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                placeholder="Please provide the SAPContractID"
                                                                                onChange={(e) => handleChange(e, "SAPContractID")}
                                                                                label="SAP Contract ID"
                                                                                margin="dense"
                                                                                value={sapContractID}
                                                                                helperText={
                                                                                    !isSAPContractIDValid &&
                                                                                    "Please provide a valid SAP Contract ID."
                                                                                }
                                                                                error={!isSAPContractIDValid}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end">
                                                                                            {sapContractIDLoading ?
                                                                                                <CircularProgress size={20} />
                                                                                                : " "}
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        </StyledFormControl>
                                                                        <div id="clientDetails" style={{ display: "none" }}>
                                                                            <StyledFormControl>
                                                                                <StyledDefaultTextField
                                                                                    label="Client Name"
                                                                                    id="ClientName"
                                                                                    margin="dense"
                                                                                    variant="outlined"
                                                                                    value={clientname}
                                                                                    onChange={(e) => handleChange(e, "Clientname")}
                                                                                    defaultValue={clientname}
                                                                                    InputProps={{
                                                                                        readOnly: true,
                                                                                    }}
                                                                                />

                                                                            </StyledFormControl>
                                                                        </div>
                                                                    </div> : ""
                                                            } */}
                                                        </div>
                                                    )
                                                }
                                                if (activeStep + 1 == 2) {
                                                    return (
                                                        <div>
                                                            <p>To better assist you, could you please let us know if you are a client or an internal user?</p>
                                                            <FormControl variant="outlined" style={{ marginTop: "-1%" }}>
                                                                <RadioGroup
                                                                    aria-label="configurationType"
                                                                    name="configurationType"
                                                                    value={configurationType}
                                                                    onChange={(e) => handleChange(e, "configurationType")}
                                                                    row
                                                                >
                                                                    <FormControlLabel
                                                                        value="client"
                                                                        control={<Radio color="primary" />}
                                                                        label={`CLIENT`}
                                                                    />
                                                                    <FormControlLabel
                                                                        value="internal"
                                                                        control={<Radio color="primary" />}
                                                                        label={`INTERNAL USER`}
                                                                    />
                                                                </RadioGroup>
                                                            </FormControl>
                                                            <StyledFormControl variant="outlined">
                                                                <StyledTooltip title="Please select Other if desired asset name is not available in the list" placement="left-start">
                                                                    <Autocomplete
                                                                        id="asset-names"
                                                                        options={assetList.sort()}
                                                                        onChange={(e, v) => handleChange(v, "assetName")}
                                                                        autoHighlight
                                                                        getOptionLabel={(option) => option.label}
                                                                        renderOption={(option) => (
                                                                            <React.Fragment>
                                                                                {option.label}
                                                                            </React.Fragment>
                                                                        )}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                label="Asset Name"
                                                                                variant="outlined"
                                                                                margin="dense"
                                                                                inputProps={{
                                                                                    ...params.inputProps,
                                                                                    autoComplete: 'new-password',
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </StyledTooltip>
                                                                {assetName === "Other" ?
                                                                    <StyledFormControl>
                                                                        <TextField
                                                                            label="Other Asset Name"
                                                                            id="OtherAsset"
                                                                            margin="dense"
                                                                            variant="outlined"
                                                                            value={otherAssetName}
                                                                            onChange={(e) => handleChange(e, "otherAssetName")}
                                                                        />
                                                                    </StyledFormControl>
                                                                    : ""
                                                                }
                                                                <StyledFormControl variant="outlined" margin="dense">
                                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                        <StyledDatePicker
                                                                            autoOk
                                                                            label="Tentative Service End Date"
                                                                            id="TentativeServiceEndDate"
                                                                            value={selectedDate}
                                                                            onChange={(e) => {
                                                                                setSelectedDate(e);
                                                                                return handleChange(
                                                                                    moment(e).format("YYYY-MM-DD"),
                                                                                    "TentativeServiceEndDate"
                                                                                );
                                                                            }}
                                                                            variant="inline"
                                                                            inputVariant="outlined"
                                                                            format="MM/dd/yyyy"
                                                                            disableCloseOnSelect={true}
                                                                            disablePast={true}
                                                                        />
                                                                    </MuiPickersUtilsProvider>
                                                                </StyledFormControl>
                                                                <StyledFormControl>
                                                                    <TextField
                                                                        label="WBSE Code"
                                                                        id="WBSEcode"
                                                                        margin="dense"
                                                                        variant="outlined"
                                                                        value={wbseCode}
                                                                        onChange={(e) => handleChange(e, "WBSEcode")}
                                                                        helperText={
                                                                            !isWBSECodeValid &&
                                                                            "Please provide a valid WBSE Code."
                                                                        }
                                                                        error={!isWBSECodeValid}
                                                                    />
                                                                </StyledFormControl>
                                                                <StyledFormControl>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        placeholder="Please provide the Secondary POC"
                                                                        onChange={(e) => handleChange(e, "SecondaryPOC")}
                                                                        label="Secondary POC"
                                                                        margin="dense"
                                                                        value={secondaryPoc}
                                                                    />
                                                                </StyledFormControl>
                                                            </StyledFormControl>
                                                            {
                                                                configurationType === "client" ?
                                                                    <div>
                                                                        <StyledFormControl>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                placeholder="Please provide the SAPContractID"
                                                                                onChange={(e) => handleChange(e, "SAPContractID")}
                                                                                label="SAP Contract ID"
                                                                                margin="dense"
                                                                                value={sapContractID}
                                                                                helperText={
                                                                                    !isSAPContractIDValid &&
                                                                                    "Please provide a valid SAP Contract ID."
                                                                                }
                                                                                error={!isSAPContractIDValid}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end">
                                                                                            {sapContractIDLoading ?
                                                                                                <CircularProgress size={20} />
                                                                                                : " "}
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        </StyledFormControl>
                                                                        <div id="clientDetails" style={{ display: "none" }}>
                                                                            <StyledFormControl>
                                                                                <StyledDefaultTextField
                                                                                    label="Client Name"
                                                                                    id="ClientName"
                                                                                    margin="dense"
                                                                                    variant="outlined"
                                                                                    value={clientname}
                                                                                    onChange={(e) => handleChange(e, "Clientname")}
                                                                                    defaultValue={clientname}
                                                                                    InputProps={{
                                                                                        readOnly: true,
                                                                                    }}
                                                                                />

                                                                            </StyledFormControl>
                                                                        </div>
                                                                    </div> : ""
                                                            }
                                                            <StyledFormControl variant="outlined" margin="dense">
                                                                <InputLabel htmlFor="outlined-assetname">Environment</InputLabel>
                                                                <StyledSelect
                                                                    onChange={(e) => handleChange(e, "env")} label="Environment" value={env}
                                                                >
                                                                    {environments.map((item) => (
                                                                        <MenuItem key={item.value} value={item.value}>
                                                                            {item.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </StyledSelect>
                                                            </StyledFormControl>

                                                        </div>
                                                        // <div>
                                                        //     <p>As OpenAI handles vast amounts of data, including proprietary information, personal data, and potentially sensitive content, it is crucial that all users have a solid understanding of data security principles and best practices. Please refer to the Accenture's HIPPA guidelines help you handle Personal data responsibly.</p>
                                                        //     <div style={{ textAlign: "center" }}>
                                                        //         <iframe src={props.pptFileUrl} width="700px" height="400px" frameborder="0"></iframe>
                                                        //         {/* <iframe src="https://myoffice.accenture.com/personal/shilpa_adikeshava_accenture_com/_layouts/15/Doc.aspx?sourcedoc={5a658d46-4d63-46c6-b2ec-9ab099aea4d8}&amp;action=embedview&amp;wdAr=1.3333333333333333" width="700px" height="400px" frameborder="0">This is an embedded <a target="_blank" href="https://office.com">Microsoft Office</a> presentation, powered by <a target="_blank" href="https://office.com/webapps">Office</a>.</iframe> */}
                                                        //     </div>
                                                        //     <p>You can also download the PowerPoint presentation (PPT) associated with the training through this {" "}
                                                        //         <a href="https://ts.accenture.com/sites/Information_Security2/Protecting%20Accenture/Shared%20Documents/Client%20Data%20Protection%20WordPress%20Site/Homepage-Right%20Side/HIPAA%20Awareness%20Training.zip" target="_blank" rel="noopener noreferrer">
                                                        //             link
                                                        //         </a> if you have trouble viewing content.</p>
                                                        // </div>
                                                    )
                                                    // if (activeStep + 1 == 3) {
                                                    //     return (
                                                    //         <div>
                                                    //             <p>As we continue to leverage OpenAI in our projects, I want to emphasize the importance of adhering to myWizard AiOps guidelines and best practices. These guidelines are designed to ensure efficient, secure, and responsible usage of OpenAI services. It is crucial that we all refer to these guidelines to maintain consistency across our assets and mitigate any potential risks.</p>
                                                    //             <div style={{ textAlign: "center" }}>
                                                    //                 <iframe src={props.pdfFileUrl} width="700px" height="400px" frameborder="0"></iframe>
                                                    //             </div>
                                                    //             <p>You can also download the PDF associated with the training through this {" "}
                                                    //                 <StyledClickableElementForFile
                                                    //                     variant="body2"
                                                    //                     onClick={(e) => fetchFilePresignedUrl(e)}
                                                    //                 >
                                                    //                     link
                                                    //                 </StyledClickableElementForFile >.</p>

                                                    //         </div>
                                                    //     )
                                                }
                                                if (activeStep + 1 == 3) {
                                                    return (
                                                        <div>
                                                            <p>Define your project, choose the right model, and specify the region — we’ll ensure everything is ready to go.</p>
                                                            <StyledTextField
                                                                label="What’s the name of your project?"
                                                                id="DomainContextRoot"
                                                                margin="dense"
                                                                variant="outlined"
                                                                value={domainContextRoot}
                                                                onChange={(e) => handleChange(e, "domainContextRoot")}
                                                                InputProps={
                                                                    domainContextRootLoading ? {
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <CircularProgress size={24} />
                                                                            </InputAdornment>
                                                                        ),
                                                                    } : ""
                                                                }
                                                                helperText={
                                                                    domainContextRoot && !isDomainContextRootValid ?
                                                                        "This Domain Context Root is already in use, please change to another name. (Only Numbers and lower-case letter are allowed)."
                                                                        : ""
                                                                }
                                                                error={domainContextRoot && !isDomainContextRootValid}
                                                            />
                                                            <StyledFormControl variant="outlined" margin="dense">
                                                                <InputLabel htmlFor="outlined-modelname">OpenAI Model Name</InputLabel>
                                                                <StyledSelect
                                                                    onChange={(e) => handleChange(e, "model")} label="OpenAI Model Name" value={model}
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>--Select a model name--</em>
                                                                    </MenuItem>
                                                                    {modelList.map(item => (
                                                                        <MenuItem key={item.Value} value={item.Value}>{item.Key}</MenuItem>
                                                                    ))}
                                                                </StyledSelect>
                                                            </StyledFormControl>
                                                            {model.length === 0 ? "" :
                                                                fetchAvailableRegionsLoading ? <p italic >Please wait...</p> :
                                                                    <StyledFormControl variant="outlined" margin="dense">
                                                                        <InputLabel htmlFor="outlined-availableRegions">OpenAI Region</InputLabel>
                                                                        <StyledSelect
                                                                            onChange={(e) => handleChange(e, "selectedRegion")} label="OpenAI Region" value={selectedRegion}
                                                                        >
                                                                            <MenuItem value="">
                                                                                <em>--Select a region--</em>
                                                                            </MenuItem>
                                                                            {regionList.map(item => (
                                                                                <MenuItem key={item} value={item}>{item}</MenuItem>
                                                                            ))}
                                                                        </StyledSelect>
                                                                    </StyledFormControl>
                                                            }

                                                        </div>
                                                    )
                                                }
                                                if (activeStep + 1 == 4) {
                                                    return (
                                                        <div>
                                                            <p>Almost there! Just need a bit more info for your approver.</p>

                                                            <StyledFormControl variant="outlined" margin="dense" >
                                                                <InputLabel htmlFor="outlined-manager">Approver</InputLabel>
                                                                <StyledSelect
                                                                    // value={values.ServiceGroup}
                                                                    onChange={(e) => handleChange(e, "manager")} label="Approver" value={manager}
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>--Select your Approver--</em>
                                                                    </MenuItem>
                                                                    {sortManagersList.map(item => (
                                                                        <MenuItem key={item} value={item}>{item}</MenuItem>
                                                                    ))}
                                                                </StyledSelect>
                                                            </StyledFormControl>
                                                            <StyledFormControl variant="outlined" margin="dense">
                                                                <TextField
                                                                    variant="outlined"
                                                                    placeholder="What are you planning to use LLM for?"
                                                                    multiline
                                                                    rows={5}
                                                                    inputProps={{
                                                                        maxLength: 300,
                                                                    }}
                                                                    onChange={(e) => handleChange(e, "usecase")}
                                                                    label="Purpose of using LLM"
                                                                    value={usecase} />
                                                            </StyledFormControl>

                                                            {/* <div>
                                                                <br></br>
                                                                <p>To ensure we have a comprehensive understanding of your ideas and plans, we kindly request you to upload a PPT presentation that outlines how you envision the integration of OpenAI in your application.</p>
                                                                <label htmlFor="upload-ppt">
                                                                    <input
                                                                        style={{ display: "none" }}
                                                                        id="upload-ppt"
                                                                        name="upload-ppt"
                                                                        type="file"
                                                                        accept=".ppt, .pptx"
                                                                        onChange={handleUploadPPTFileInputChange}
                                                                    />

                                                                    <Button color="primary" variant="contained" component="span">
                                                                        <AddIcon />Upload PPT
                                                                    </Button>{" "}&nbsp;&nbsp;{pptName}
                                                                </label>
                                                            </div> */}

                                                        </div>
                                                    )
                                                }
                                                if (activeStep + 1 == 5) {
                                                    return (
                                                        <div>
                                                            <p>Please take the time to carefully review all the terms and conditions before checking the checkbox. </p>
                                                            <ul>
                                                                <li>As an employee of Accenture Ltd, I understand and acknowledge the <b>significance of responsible use of LLM model</b>. I commit to utilizing the model in accordance with the guidelines and policies set forth by the company.
                                                                </li>
                                                                <li>I acknowledge that using <b>LLM model requires adherence to ethical and legal standards</b>. I will use the model responsibly, ensuring that generated content aligns with our company values and complies with relevant laws and regulations.</li>
                                                                <li>By signing below, I affirm my commitment to using LLM model effectively and responsibly. I will exercise caution when <b>generating content and make informed decisions to avoid biased or misleading outputs</b>.
                                                                </li>
                                                                <li>I recognize that responsible use of LLM model is essential for maintaining <b>trust and integrity</b>. I pledge to validate and review the generated content to ensure accuracy, fairness, and appropriateness before sharing or utilizing it.
                                                                </li>
                                                                <li>I understand that using LLM model requires considering potential risks and limitations. <b>I will actively seek to enhance my understanding of the model's capabilities and constraints</b> to make informed decisions while leveraging its capabilities.
                                                                </li>
                                                                <li>By agreeing to this statement, I affirm my commitment to following best practices when using LLM model. <b>I will critically evaluate and verify the generated content, taking responsibility for its accuracy, relevance, and compliance</b>.
                                                                </li>
                                                                <li>I acknowledge that training and education are crucial for safe and effective use of LLM model. I will actively participate in relevant training programs and stay updated on best practices to <b>maximize the benefits while mitigating any potential risks</b>.
                                                                </li>
                                                                <li>I understand that using LLM model requires protecting the privacy and confidentiality of data. <b>I will handle any sensitive or confidential information in accordance with data privacy policies and security protocols.</b></li>
                                                                <li>By acknowledging this statement, I confirm that I will use LLM model responsibly and respect the intellectual property rights of others. <b>I will avoid generating or sharing content that may infringe upon copyrights or violate any legal obligations.</b>
                                                                </li>
                                                                <li><b>I hereby acknowledge that the responsible use of LLM model is a shared responsibility. I will actively contribute to fostering a culture of ethical AI usage and collaborate with my colleagues to ensure its effective and beneficial deployment.</b></li>
                                                                <li><b>I hereby acknowledge that I have completed the AiOps recommended trainings before raising this request.</b>
                                                                </li>

                                                            </ul>
                                                            <FormControlLabel onChange={(e) => handleChange(e, "tc")} control={<Checkbox />} label="I agree to the above terms & conditions" />
                                                        </div>
                                                    )
                                                }

                                            })()
                                        }
                                    </Typography>
                                    <div>
                                        <div style={{ float: "left" }}>
                                            <AcceptButton
                                                color="inherit"
                                                disabled={activeStep === 0}
                                                onClick={handleBack}
                                                sx={{ mr: 1 }}
                                                label={"Back"}
                                                className={activeStep === 0 ? classes.backButton : classes.actionButton}
                                            ></AcceptButton>
                                        </div>
                                        {requestType === "ATR" ?
                                            <div style={{ float: "right" }}>
                                                {
                                                    <AcceptButton className={classes.actionButton} onClick={handleComplete} disabled={isAllInputsCorrect} label="Submit" />
                                                }
                                            </div>
                                            :
                                            <div style={{ float: "right" }}>
                                                {
                                                    (activeStep + 1) === steps.length ? (
                                                        <AcceptButton className={classes.actionButton} onClick={handleComplete} disabled={isAllInputsCorrect} label="Submit" />
                                                    ) : (
                                                        <AcceptButton onClick={() => {
                                                            const newCompleted = completed;
                                                            newCompleted[activeStep] = true;
                                                            setCompleted(newCompleted);
                                                            // handleNext();
                                                            handleSave(activeStep);
                                                        }} className={classes.actionButton} disabled={isAllInputsCorrect || loading} label='Next' />
                                                    )
                                                }
                                            </div>
                                        }
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </Box>
                </DialogContentText>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
            </DialogContent>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        idToken: state.auth.idToken,
        email: state.auth.userDetails.email
            ? state.auth.userDetails.email.split("@")[0]
            : "",
    };
};


export default connect(mapStateToProps, {})(RequestForm);